import { useDispatch, useSelector } from "react-redux"
import { updateContactVisible, updateDimmed } from "../../../features/forms/formsSlice";
import emailjs from "emailjs-com";
import { useEffect, useRef, useState } from "react";
import {
  ContactFormWrapper,
  InputWrapper,
  Label,
  NameInput,
  EmailInput,
  PhoneInput,
  MessageArea,
  ButtonsWrapper,
  SendButton,
  CancelButton,
  Title,
  Subtitle,
} from "./ContactFormStyle";
import { sendEmail } from "../../../i18n/11_sendEmail";


const ContactForm = ({ contactVisible }) => {

  const [closeButton, setCloseButton] = useState("Cancel")
  
  const lang = useSelector(state => state.lang.lang)
  
  const t = sendEmail[lang]
  
  const [updateMessage, setUpdateMessage] = useState(t.messageFillout)

  const formRef = useRef();

  const dispatch = useDispatch()

  const sendEmailfunction = (e) => {
    e.preventDefault();
    setUpdateMessage(t.messageHoldon)
    emailjs
      .sendForm(
        "vikhulei",
        "template_81kf2cg",
        formRef.current,
        "12WJOfaFSSsyIysem"
      )
      .then(
        () => {
          setUpdateMessage(t.messageEmailsent);
          setCloseButton("Close")
          // onClose && onClose();
        },
        (error) => {
          setUpdateMessage("Something went wrong");
          console.error(error);
        }
      );
  };

  useEffect(() => {
    setUpdateMessage(t.messageFillout)
  }, [])

  const clickCancel = (e) => {
    e.preventDefault()
    if (formRef.current) {
      formRef.current.reset();
    }
    setUpdateMessage(t.messageFillout);
    setCloseButton("Cancel");
    dispatch(updateContactVisible(false))
    dispatch(updateDimmed(false))
    setUpdateMessage("")
  }

  return (
    <ContactFormWrapper
      ref={formRef}
      onSubmit={sendEmailfunction}
      contactVisible={contactVisible}
    >
      <Title>{t.heading}</Title>
      <Subtitle>{updateMessage || t.messageFillout}</Subtitle>
      <InputWrapper>
        <Label>{t.name}</Label>
        <NameInput name="name" placeholder="Your Name" required />
      </InputWrapper>

      <InputWrapper>
        <Label>{t.email}</Label>
        <EmailInput
          name="email"
          type="email"
          placeholder="Your Email"
          required
        />
      </InputWrapper>

      <InputWrapper>
        <Label>{t.phone}</Label>
        <PhoneInput name="phone" placeholder="Phone (optional)" />
      </InputWrapper>

      <InputWrapper>
        <Label>{t.message}</Label>
        <MessageArea name="message" placeholder="Your Message" required />
      </InputWrapper>

      <ButtonsWrapper>
        <SendButton type="submit">Send</SendButton>
        <CancelButton type="button" onClick={clickCancel}>
          {closeButton}
        </CancelButton>
      </ButtonsWrapper>
    </ContactFormWrapper>
  );
};

export default ContactForm;
